import { IFile, ILocaleValue, IPageableResponseData } from '..';

export interface IAdsCategory  {
    id: string;
    name: ILocaleValue;
    icon?: IFile | string;
    isVisible?: boolean;
    hasRelation?: boolean;
    iconName?: string;
}

export interface ICreateAdsCategory  {
    name: ILocaleValue;
    icon?: IFile | string;
}

export interface IUpdateAdsCategory extends ICreateAdsCategory {
    id: string;
    isVisible?: boolean;
}

export interface IAdsCategoryPageableResponseData extends IPageableResponseData<IAdsCategory> {

}

export enum AdsCategory {
    ESTATE = "1ee89257-281a-6b80-8d0c-bd2bc8dbbdc2",
    WORK = "1ee89257-281a-6b81-3a1f-fdd60e443749",
    SERVICE = "1ee89257-281a-6b82-2706-b4d9cb3f9ac0",
    VEHICLE = "1ee89257-281a-6b83-0703-f48b1bd98151",
    BUSINESS = "1ee9e846-b72e-64a0-8b4e-b257a39b54b5",
    PAID_SERVICE = "1eecfef7-e165-6431-235e-b4ba7c22799f",
    BUY_SELL = "1eecfef7-e162-6d22-8f9b-aa3396a73fc6",
    TRUCKING = "1eecfef7-e162-6d20-a0b0-1d70a08ff52b",
    EDUCATION = "1eecfef7-e162-6d21-2f48-ebe63f561b0c",
    FOOD = "1eecfef7-e165-6430-496d-d9ab3dba97b3",
    UPCOMING_EVENTS = "1eed3452-f53c-6f90-f64c-9dcae1b0a2c7",
}
